import { getDataForSalesFor } from "./utilts";

export const onSubmitDate = async (
  url,
  draft,
  previewData,
  leadId,
  resultData,
  leadResultsDetail
) => {
  const subdata = {
    customer: previewData.customer || "",
    city: previewData.city || "",
    street: previewData.st || "",
    leadId: leadId,
    // leadId: Math.random().toString(),
    measurements: previewData.measurements,
    gutterHeight: previewData?.gutter_height || [],
    newMeterInside: previewData?.newMeterInside || 0,
    newMeterOutside: previewData?.newMeterOutSide || 0,
    roof: {
      sumOfAllFootage:
        Number(previewData?.total_gutter_footage) +
        Number(previewData?.aelbows) +
        Number(previewData?.belbows) +
        Number(previewData?.roundElbows) +
        Number(previewData?.offsetElbows) +
        Number(previewData.downspout_footage),
      roofType: previewData.roof_type || "",
      gutterType: previewData.gutter_type || "",
      gutterColor: previewData.color || "",
      gutterSize: previewData.gutter_size || "",
      totalGutterFootage: previewData.total_gutter_footage || 0,
      downSpout: previewData.downspout || "",
      downSpoutColor: previewData.downspout_color || "",

      downSpoutFootage: {
        ofAElbows: previewData.aelbows || "",
        ofBElbows: previewData.belbows || "",
        ofRoundElbows: previewData.roundElbows || "",
        ofOffsetElbows: previewData.offsetElbows || "",
        totalFootage: previewData.downspout_footage || 0,
      },
    },

    misc: {
      ofMitersOutside: previewData.outside || "",
      ofMitersInside: previewData.inside || "",
      ofEndcapsRights: previewData.rights || "",
      ofEndcapsLefts: previewData.lefts || "",
      ofSproutSavers: previewData.savers || "",
      ofRoofStraps: previewData.straps || "",
      ofwedges: previewData.wedges || "",
      partialInstall: previewData.partial_install == "Yes" ? true : false,
    },

    fasciaReplacement: {
      type: previewData.fascia_replacement || "",
      totalFootage: previewData.fascia_total_footage || 0,
      size:
        previewData.fascia_size === "Other"
          ? previewData.fascia_other_size || ""
          : previewData.fascia_size || "",
      productType:
        previewData.fascia_type == "Other"
          ? previewData.fascia_other_value
          : previewData.fascia_type,
      productDetail:
        previewData.fascia_other == "Other"
          ? previewData.fascia_other_value
          : previewData.fascia_other,
      totalFtOfNewWrap: previewData.fascia_wrap || "",
      fascia_color: previewData.fascia_color,
    },

    soffitReplacement: {
      replacementType: previewData.soffit_replacement || "",
      soffitType:
        previewData.soffit_other == "Other"
          ? previewData.soffit_other_value
          : previewData.soffit_other,
      soffitColor: previewData.soffit_color || "None",
      totalFootage: previewData.soffit_total_footage || 0,
    },
    porchCeiling: previewData?.porch_ceiling,
    metalWrappedColor:
      previewData.fascia_other == "Metal Wrapped"
        ? previewData?.metal_wrapped_color
        : "",
  };

  const dataForSalesForce = getDataForSalesFor(previewData, subdata.leadId);
  dataForSalesForce.measurements = dataForSalesForce.measurements.map(
    (story, index, measurements) => {
      const updatedStory = Object.fromEntries(
        Object.entries(story).map(([key, value]) => [
          key,
          value === "" ? 0 : value,
        ])
      );

      return updatedStory;
    }
  );

  dataForSalesForce.porchCeiling = dataForSalesForce.porchCeiling.map(
    (item) => ({
      ...item,
      squareFeet: item.squareFeet * 15,
    })
  );
  if (resultData.lastPrice == "") {
    resultData.lastPrice = 0;
  }
  dataForSalesForce.costPriceTotal =
    (dataForSalesForce?.costPrice?.newMeterInside || 0) +
    (dataForSalesForce?.costPrice?.newMeterOutSide || 0) +
    (dataForSalesForce?.costPrice?.totalGutterDownspoutElbows || 0) +
    (dataForSalesForce?.costPrice?.ofWedges || 0) +
    (dataForSalesForce?.costPrice?.fasciaTotalFootage || 0) +
    (dataForSalesForce?.costPrice?.totalFTOfNewWrap || 0) +
    (dataForSalesForce?.costPrice?.soffitTotalFootage || 0) +
    (dataForSalesForce?.costPrice?.porchCeiling?.reduce(
      (sum, item) => sum + item.squareFeet,
      0
    ) || 0);
  dataForSalesForce.parPriceTotal =
    ((dataForSalesForce?.retailPrice?.newMeterInside || 0) +
      (dataForSalesForce?.retailPrice?.newMeterOutSide || 0) +
      (dataForSalesForce?.retailPrice?.totalGutterDownspoutElbows || 0) +
      (dataForSalesForce?.retailPrice?.ofWedges || 0) +
      (dataForSalesForce?.retailPrice?.fasciaTotalFootage || 0) +
      (dataForSalesForce?.retailPrice?.totalFTOfNewWrap || 0) +
      (dataForSalesForce?.retailPrice?.soffitTotalFootage || 0) +
      (dataForSalesForce?.retailPrice?.porchCeiling?.reduce(
        (sum, item) => sum + item.squareFeet,
        0
      ) || 0) +
      500) *
    0.65;
  dataForSalesForce.RetailPriceTotal =
    (dataForSalesForce?.retailPrice?.newMeterInside || 0) +
    (dataForSalesForce?.retailPrice?.newMeterOutSide || 0) +
    (dataForSalesForce?.retailPrice?.totalGutterDownspoutElbows || 0) +
    (dataForSalesForce?.retailPrice?.ofWedges || 0) +
    (dataForSalesForce?.retailPrice?.fasciaTotalFootage || 0) +
    (dataForSalesForce?.retailPrice?.totalFTOfNewWrap || 0) +
    (dataForSalesForce?.retailPrice?.soffitTotalFootage || 0) +
    (dataForSalesForce?.retailPrice?.porchCeiling?.reduce(
      (sum, item) => sum + item.squareFeet,
      0
    ) || 0) +
    500;
  dataForSalesForce.porchCeiling = dataForSalesForce.porchCeiling.map(
    (item, index) => ({
      location: item.location || "",
      length: item.length === "" ? 0 : item.length,
      width: item.width === "" ? 0 : item.width,
      squareFeet:
        item.length === "" || item.width === "" ? 0 : item.length * item.width,
      squareFeetCostPrice:
        dataForSalesForce?.costPrice?.porchCeiling?.length > 0
          ? dataForSalesForce?.costPrice?.porchCeiling[index]?.squareFeet
          : 0,
      squareFeetRetailPrice:
        dataForSalesForce?.retailPrice?.porchCeiling?.length > 0
          ? dataForSalesForce?.retailPrice?.porchCeiling[index]?.squareFeet
          : 0,
    })
  );
  resultData.resultType =
    resultData.resultType || leadResultsDetail.resultType || "Demo";
  resultData.resultReason =
    resultData.resultReason || leadResultsDetail.resultReason || "";
  resultData.oneLeg = resultData.oneLeg || leadResultsDetail.oneLeg || "mr";
  resultData.lastPrice =
    resultData.lastPrice || leadResultsDetail.lastPrice || 0;
  dataForSalesForce.results = resultData;
  dataForSalesForce.costPricing = dataForSalesForce.costPrice;
  dataForSalesForce.retailPricing = dataForSalesForce.retailPrice;
  dataForSalesForce.measurements = dataForSalesForce.measurements.slice(0, 7);

  dataForSalesForce.fasciaReplacement.fascia_color =
    dataForSalesForce.fasciaReplacement.fascia_color == "None"
      ? ""
      : dataForSalesForce.fasciaReplacement.fascia_color;
  dataForSalesForce.soffitReplacement.soffitColor =
    dataForSalesForce.soffitReplacement.soffitColor == "None"
      ? ""
      : dataForSalesForce.soffitReplacement.soffitColor;

  delete dataForSalesForce.costPrice;
  delete dataForSalesForce.retailPrice;
  dataForSalesForce.costPrice = dataForSalesForce.costPriceTotal;
  dataForSalesForce.parPrice = dataForSalesForce.parPriceTotal;
  dataForSalesForce.RetailPrice = dataForSalesForce.RetailPriceTotal;
  delete dataForSalesForce.costPricing.porchCeiling;
  delete dataForSalesForce.retailPricing.porchCeiling;
  delete dataForSalesForce.costPriceTotal;
  delete dataForSalesForce.parPriceTotal;
  delete dataForSalesForce.RetailPriceTotal;
  const total = dataForSalesForce.measurements.slice(0, -1).reduce(
    (acc, obj) => {
      acc.firstStory += obj.firstStory;
      acc.secondStory += obj.secondStory;
      acc.thirdStory += obj.thirdStory;
      return acc;
    },
    { firstStory: 0, secondStory: 0, thirdStory: 0 }
  );

  // Update the last object
  dataForSalesForce.measurements[dataForSalesForce.measurements.length - 1] =
    total;
  dataForSalesForce.gutter_height = subdata.gutterHeight;
  // if ('thirldStoryTotal' in dataForSalesForce.costPricing) {
  dataForSalesForce.costPricing.thirdStoryTotal =
    dataForSalesForce.costPricing.thirldSotryTotal;
  delete dataForSalesForce.costPricing.thirldSotryTotal;
  // }

  // For retailPricing:
  // if ('thirldStoryTotal' in dataForSalesForce.retailPricing) {
  dataForSalesForce.retailPricing.thirdStoryTotal =
    dataForSalesForce.retailPricing.thirldSotryTotal;
  delete dataForSalesForce.retailPricing.thirldSotryTotal;
  // }
  dataForSalesForce.roof.gutterSize =
    dataForSalesForce.roof.gutterSize.length > 0
      ? dataForSalesForce.roof.gutterSize[0]
      : "4";
  dataForSalesForce.leadId = dataForSalesForce.leadId || "";
  const formData = new FormData();
  let roofTypeValue = subdata.roof.roofType;
  if (typeof roofTypeValue === "string" && roofTypeValue.includes(",")) {
    // Convert comma-separated string to array
    roofTypeValue = roofTypeValue.split(",").map((item) => item.trim());
  }
  // Flattening and appending each key-value pair
  formData.append("customer", subdata.customer);
  formData.append("city", subdata.city);
  formData.append("street", subdata.street);
  formData.append("leadId", subdata.leadId);
  // formData.append("gutterHeight", subdata.gutterHeight);
  subdata.gutterHeight.forEach((value, index) => {
    formData.append("gutterHeight[]", value);
  });
  formData.append("newMeterInside", subdata.newMeterInside);
  formData.append("newMeterOutside", previewData?.newMeterOutSide || 0);

  // Roof data
  formData.append("ribbedRoofQuantity", dataForSalesForce.ribbedRoofQuantity);
  //     if (Array.isArray(roofTypeValue)) {
  //     roofTypeValue.forEach((item,i) => {
  //         formData.append(`roof.roofType[${i}]`, item);
  //     });

  // } else {
  //   formData.append("roof.roofType", roofTypeValue);
  // }
  formData.append("roof.roofType", roofTypeValue);

  formData.append("roof.gutterType", subdata.roof.gutterType);
  formData.append("roof.gutterColor", subdata.roof.gutterColor);
 const gutterSizes = Array.isArray(subdata.roof.gutterSize)
  ? subdata.roof.gutterSize
  : typeof subdata.roof.gutterSize === 'string'
    ? subdata.roof.gutterSize.split(',').map(s => s.trim())
    : [subdata.roof.gutterSize];


  gutterSizes.forEach((value) => {
    formData.append("roof.gutterSize[]", value);
  });
  // formData.append("roof.gutterSize", [4]);
  formData.append("roof.totalGutterFootage", subdata.roof.totalGutterFootage);
  formData.append("roof.downSpout", subdata.roof.downSpout);
  formData.append("roof.downSpoutColor", subdata.roof.downSpoutColor);

  formData.append(
    "roof.downSpoutFootage.ofAElbows",
    subdata.roof.downSpoutFootage.ofAElbows
  );
  formData.append(
    "roof.downSpoutFootage.ofBElbows",
    subdata.roof.downSpoutFootage.ofBElbows
  );
  formData.append(
    "roof.downSpoutFootage.ofRoundElbows",
    subdata.roof.downSpoutFootage.ofRoundElbows
  );
  formData.append(
    "roof.downSpoutFootage.ofOffsetElbows",
    subdata.roof.downSpoutFootage.ofOffsetElbows
  );
  formData.append(
    "roof.downSpoutFootage.totalFootage",
    subdata.roof.downSpoutFootage.totalFootage
  );
  formData.append("roof.sumOfAllFootage", subdata.roof.sumOfAllFootage);

  // Misc data
  formData.append("misc.ofMitersOutside", subdata.misc.ofMitersOutside);
  formData.append("misc.ofMitersInside", subdata.misc.ofMitersInside);
  formData.append("misc.ofEndcapsRights", subdata.misc.ofEndcapsRights);
  formData.append("misc.ofEndcapsLefts", subdata.misc.ofEndcapsLefts);
  formData.append("misc.ofSproutSavers", subdata.misc.ofSproutSavers);
  formData.append("misc.ofRoofStraps", subdata.misc.ofRoofStraps);
  formData.append("misc.ofwedges", subdata.misc.ofwedges);
  formData.append("misc.partialInstall", subdata.misc.partialInstall);
  formData.append(
    "metalWrappedColor",
    previewData.fascia_other == "Metal Wrapped"
      ? previewData.metal_wrapped_color
      : ""
  );
  // Fascia Replacement
  formData.append("fasciaReplacement.type", subdata.fasciaReplacement.type);
  Object.entries(resultData).forEach(([key, value]) => {
    formData.append(`results[${key}]`, value);
  });
  formData.append(
    "fasciaReplacement.totalFootage",
    subdata.fasciaReplacement.totalFootage
  );
  formData.append("fasciaReplacement.size", subdata.fasciaReplacement.size);
  formData.append(
    "fasciaReplacement.productType",
    subdata.fasciaReplacement.productType
  );
  formData.append(
    "fasciaReplacement.productDetail",
    subdata.fasciaReplacement.productDetail
  );
  formData.append(
    "fasciaReplacement.totalFtOfNewWrap",
    subdata.fasciaReplacement.totalFtOfNewWrap
  );
  formData.append(
    "fasciaReplacement.fascia_color",
    subdata.fasciaReplacement.fascia_color
  );
  // Soffit Replacement
  formData.append(
    "soffitReplacement.replacementType",
    subdata.soffitReplacement.replacementType
  );
  formData.append(
    "soffitReplacement.soffitType",
    subdata.soffitReplacement.soffitType
  );
  formData.append(
    "soffitReplacement.soffitColor",
    subdata.soffitReplacement.soffitColor
  );
  formData.append(
    "soffitReplacement.totalFootage",
    subdata.soffitReplacement.totalFootage
  );

  if (Array.isArray(subdata.porchCeiling)) {
    subdata.porchCeiling.forEach((item, index) => {
      Object.keys(item).forEach((key) => {
        formData.append(`porchCeiling[${index}][${key}]`, item[key]);
      });
    });
  }

  if (Array.isArray(subdata.measurements)) {
    subdata.measurements.forEach((item, index) => {
      Object.keys(item).forEach((key) => {
        formData.append(`measurements[${index}][${key}]`, item[key]);
      });
    });
  }

  if (previewData.files && Array.isArray(previewData.files)) {
    previewData.files.forEach((file, index) => {
      formData.append(`files`, file);
    });
  }
  // await salesForceLogin(dataForSalesForce);
  Object.keys(dataForSalesForce.retailPricing).forEach((key) => {
    formData.append(
      `retailPricing.${key}`,
      dataForSalesForce.retailPricing[key]
    );
  });
  Object.keys(dataForSalesForce.costPricing).forEach((key) => {
    formData.append(`costPricing.${key}`, dataForSalesForce.costPricing[key]);
  });
  formData.append(`parPrice`, dataForSalesForce.parPrice);
  formData.append(`costPrice`, dataForSalesForce.costPrice);
  formData.append(`RetailPrice`, dataForSalesForce.RetailPrice);
   previewData?.images?.forEach((value, index) => {
    formData.append("images[]", value);
  });
  return formData;
};
